import React, {Component} from 'react';
import {connect} from 'react-redux';
import Action from 'components/organisms/nhl-legacy-team-stacking/actions';

class LineGroupsChecking extends Component {
    onChange(lineGroup, isChecked) {
        this.props.dispatch(Action.setLineGroupsForStackNumber(
            {[lineGroup]: isChecked},
            this.props.stackNumber,
        ));
    }
    render() {
        const {stackNumber, stacking} = this.props;
        const lineGroups = stacking.getLineGroupsByStackNumber(stackNumber);

        return (
            <div className="chk-group-container">
                <strong className="chk-group-title">Line Groups:</strong>
                <div className="chk-group">
                    {Object.keys(lineGroups).map(lineGroup => (
                        <label key={lineGroup}>
                            <input
                                type="checkbox"
                                checked={lineGroups[lineGroup]}
                                onChange={e => ::this.onChange(lineGroup, e.target.checked)} />
                            <span>{lineGroup}</span>
                        </label>
                    ))}
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        nhlLegacyTeamStacking,
    } = state;

    return {
        stacking: nhlLegacyTeamStacking,
    }
}

export default connect(mapStatesToProps)(LineGroupsChecking);
